var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { cloneDeep } from 'lodash';
function getParticleSystems(chapter) {
    if (chapter.customData === undefined) {
        return [];
    }
    if (chapter.customData.particleSystems === undefined) {
        return [];
    }
    return chapter.customData.particleSystems;
}
// there is already a chapter id. replace it
function buildParticleSystemId(chapterId, currentId) {
    var root = currentId.split('/').pop();
    return chapterId + "/" + root;
}
// build a look up table of new -> old particle system ids
function particleSystemNameLookup(_chapters) {
    return _chapters.reduce(function (acc, chapter) {
        var e_1, _a;
        try {
            for (var _b = __values(getParticleSystems(chapter)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var name_1 = _c.value;
                var newName = buildParticleSystemId(chapter.id, name_1);
                acc[newName] = name_1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return acc;
    }, {});
}
// assign updated particle names back to chapters
function setParticlesForChapter(_chapters) {
    return _chapters.map(function (chapter) {
        var particleSystems = getParticleSystems(chapter).map(function (name) { return buildParticleSystemId(chapter.id, name); });
        return __assign({}, chapter, { customData: __assign({}, chapter.customData, { particleSystems: particleSystems }) });
    });
}
// given a lookup, and the original particle systems,
// clone and rename to match what is stated in each chapter
function cloneAndRenameNeededParticles(nameLookup, particleSystemRepo) {
    return Object.keys(nameLookup).reduce(function (acc, newName) {
        var oldName = nameLookup[newName];
        var clone = cloneDeep(particleSystemRepo.find(function (particle) { return particle.id === oldName; }));
        clone.id = newName;
        acc.push(clone);
        return acc;
    }, []);
}
// when a bookmark is saved,
// all chapter ids change
// update particle system ids in chapter
// and update customData with new particleSystem ids
// return chapters and customData
// merging chapters and customData is only a concern of combineModules
export function updateParticleSystems(chapters, customDataParticleSystems) {
    var nameLookupForParticles = particleSystemNameLookup(chapters);
    var currentChaptersWithUpdatedParticles = setParticlesForChapter(chapters);
    var currentParticleSystemsRenamed = cloneAndRenameNeededParticles(nameLookupForParticles, customDataParticleSystems);
    return {
        particleSystemsForCustomData: currentParticleSystemsRenamed,
        chapters: currentChaptersWithUpdatedParticles
    };
}
